export const device = {
  mobile: '@media (min-width: 320px)',
  tablet: '@media (min-width: 768px)',
  desktop: '@media (min-width: 1024px)',
  tv: '@media (min-width: 3096px)',
};
